export default function imageMap(image: any): App.Image {
  return {
    id: image.id_cloudinary_external || image.id,
    title: image.title,
  }
}
